import { type ReactNode, useEffect, useId } from 'react';

import { useLayerManager } from './context';

interface LayerProps {
  isOpen: boolean;
  children: ReactNode | ((data: { id: string }) => ReactNode);
}

function useLayer(isOpen: boolean) {
  const { enterLayer, exitLayer } = useLayerManager();
  const id = useId();

  useEffect(() => {
    if (!isOpen) return;

    enterLayer(id);

    return () => {
      exitLayer(id);
    };
  }, [enterLayer, exitLayer, id, isOpen]);

  return id;
}

export function Layer({ children, isOpen }: LayerProps) {
  const id = useLayer(isOpen);

  return typeof children === 'function' ? children({ id }) : children;
}
